"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateDeviceDataPointMutation = exports.useSetDeviceOffMutation = exports.useSetDeviceSwitchMutation = exports.useGetDeviceActionsQuery = exports.useGetDeviceReadingsSummaryQuery = exports.useLazyGetDeviceReadingsQuery = exports.useGetDeviceReadingsQuery = exports.useSetDeviceAlarmsMutation = exports.useCreateDeviceMutation = exports.useGetDevicesQuery = exports.useGetDeviceQuery = exports.deviceApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.deviceApi = (0, react_1.createApi)({
    reducerPath: "deviceApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["device"],
    endpoints: function (builder) { return ({
        getDevice: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/v1/device/".concat(id);
            },
            providesTags: ["device"],
        }),
        getDevices: builder.query({
            // userId is deliberately part of the RTK Query argument. The endpoint
            // derives authorization from the token, but cached results must not be
            // reused after another account signs in on the same browser.
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/device", function (arg) { return ({ facility_id: arg.facilityId }); }),
            providesTags: ["device"],
        }),
        createDevice: builder.mutation({
            query: function (body) { return ({ url: "/v1/device", method: "POST", body: body }); },
            invalidatesTags: ["device"],
        }),
        setDeviceAlarms: builder.mutation({
            query: function (_a) {
                var id = _a.id, alarms = _a.alarms;
                return ({ url: "/v1/device/".concat(id, "/alarms"), method: "PATCH", body: { alarms: alarms } });
            },
            invalidatesTags: ["device"],
        }),
        getDeviceReadings: builder.query({
            query: function (_a) {
                var id = _a.id, from = _a.from, to = _a.to, before = _a.before, size = _a.size;
                return (0, api_url_1.appendUrlParams)("/v1/device/".concat(id, "/readings"), { from: from, to: to, before: before, size: size });
            },
            keepUnusedDataFor: 0,
        }),
        getDeviceReadingsSummary: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/device/readings/summary", function (arg) { return ({
                facility_id: arg.facilityId,
                area_id: arg.areaId,
                from: arg.from,
                to: arg.to,
                bucket: arg.bucket,
            }); }),
            keepUnusedDataFor: 0,
        }),
        getDeviceActions: builder.query({
            query: function (_a) {
                var id = _a.id, pageNumber = _a.pageNumber, size = _a.size;
                return (0, api_url_1.appendUrlParams)("/v1/device/".concat(id, "/actions"), { pageNumber: pageNumber, size: size });
            },
            providesTags: ["device"],
        }),
        setDeviceSwitch: builder.mutation({
            query: function (_a) {
                var id = _a.id, on = _a.on, channel = _a.channel;
                return ({ url: "/v1/device/".concat(id, "/switch"), method: "PATCH", body: __assign({ on: on }, (channel === undefined ? {} : { channel: channel })) });
            },
            invalidatesTags: ["device"],
        }),
        setDeviceOff: builder.mutation({
            query: function (_a) {
                var id = _a.id, off = _a.off;
                return ({ url: "/v1/device/".concat(id, "/off"), method: "PATCH", body: { off: off } });
            },
            invalidatesTags: ["device"],
        }),
        updateDeviceDataPoint: builder.mutation({
            query: function (_a) {
                var id = _a.id, key = _a.key, body = __rest(_a, ["id", "key"]);
                return ({ url: "/v1/device/".concat(id, "/data-points/").concat(key), method: "PATCH", body: body });
            },
            invalidatesTags: ["device"],
        }),
    }); },
});
exports.useGetDeviceQuery = exports.deviceApi.useGetDeviceQuery, exports.useGetDevicesQuery = exports.deviceApi.useGetDevicesQuery, exports.useCreateDeviceMutation = exports.deviceApi.useCreateDeviceMutation, exports.useSetDeviceAlarmsMutation = exports.deviceApi.useSetDeviceAlarmsMutation, exports.useGetDeviceReadingsQuery = exports.deviceApi.useGetDeviceReadingsQuery, exports.useLazyGetDeviceReadingsQuery = exports.deviceApi.useLazyGetDeviceReadingsQuery, exports.useGetDeviceReadingsSummaryQuery = exports.deviceApi.useGetDeviceReadingsSummaryQuery, exports.useGetDeviceActionsQuery = exports.deviceApi.useGetDeviceActionsQuery, exports.useSetDeviceSwitchMutation = exports.deviceApi.useSetDeviceSwitchMutation, exports.useSetDeviceOffMutation = exports.deviceApi.useSetDeviceOffMutation, exports.useUpdateDeviceDataPointMutation = exports.deviceApi.useUpdateDeviceDataPointMutation;
